import type {
  ConsentType,
  DsarRequestPayload,
  LoginResponse,
  LoginVariables,
  PasswordRequirementsResponse,
  RegisterCdpVariables,
  RegisterVariables,
  RegisterVariablesError,
  RegisterVariablesSuccess,
  VerifyUpdateEmailResponse,
} from "@jti/fe-common";
import type { AuthenticationStrategiesConfig } from "@jti/rest-api-types";

import type { RestResponseType } from "../../Rest";

export type ValidateSessionResponse = Pick<RestResponseType, "statusCode">;

export type ResetPasswordResponse = {
  message: string;
};

export type ResetPasswordRequest = {
  newPassword: string;
  ciamToken: string;
  confirmPassword: string;
  actionType: PasswordAction;
  consents: ConsentType[];
};

export type RegistrationPublicConfiguration = {
  requiresDeviceRegistration: boolean;
};

export enum PasswordAction {
  resetPassword = "reset_password",
  setPassword = "set_password",
}

export interface CasAuthApiContract {
  validate: (ciamToken: string, isCached?: boolean) => Promise<RestResponseType>;
  login: (variables: LoginVariables) => Promise<RestResponseType<LoginResponse>>;
  register: (variables: RegisterVariables, dobFormat?: string) => Promise<RestResponseType<RegisterVariablesSuccess>>;
  registerCdpUser: (
    variables: RegisterCdpVariables
  ) => Promise<RestResponseType<RegisterVariablesSuccess | RegisterVariablesError>>;
  unregister: (uuid?: string, ciamToken?: string) => Promise<unknown>;
  forgotPassword: (email: string) => Promise<{ message: string }>;
  resetConsumerPassword: (variables: ResetPasswordRequest) => Promise<ResetPasswordResponse>;
  verifyEmailUpdate: (uuidOfRequest: string) => Promise<VerifyUpdateEmailResponse>;
  verifyConsumer: (email: string) => Promise<{ statusCode: string }>;
  getPasswordRequirements: () => Promise<RestResponseType<PasswordRequirementsResponse>>;
  getRegistrationPublicConfiguration: () => Promise<RestResponseType<RegistrationPublicConfiguration>>;
  dsarRequest: (variables: DsarRequestPayload) => Promise<RestResponseType>;
  getAvailableAuthMethods: () => Promise<RestResponseType<{ availableAuthMethods?: AuthenticationStrategiesConfig }>>;
  deactivateAccount(uuid?: string): Promise<void>;
}
